import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';
import Carousel from '../Carousel';
import CarouselItem from '../CarouselItem';
import {kebabCase} from 'lodash';
export interface VHSProcessItems {
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Text
	 */
	text?: string;
}

export interface IVHSProcessProps extends IBaseElementProps {
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Please provide a unique ID for this particular accordion. It should be lowercase with hyphens separating the words, like main-carousel or student-spotlights. Do not include spaces or any other characters. Try to keep it relatively short.
	 * @control uniqueid
	 */
	id?: string;
	/**
	 * Items
	 */
	items?: VHSProcessItems[];
}

/**
 * Process
 * @block
 * @icon performance
 */
const VHSProcess: React.FC<IVHSProcessProps> = ({
	id,
	heading,
	items = [],
	className,
	classNames = [],
}) => (
	<div className={className || cn('vhs-process', ...classNames)}>
		<div className="vhs-process__container">
			{heading && <h2 className="vhs-process__heading">{heading}</h2>}
			{items.length > 0 &&
				<div className="vhs-process__wrapper">
					<Carousel
						id={`process-${id || kebabCase(heading)}`}
					>
						{items.map(({ heading, text }, index) => {
							if (index < 5) {
								return (
									<CarouselItem key={index}>
										<div className="vhs-process__content">
											<h2>{heading}</h2>
											<p>{text}</p>
										</div>
									</CarouselItem>
								)}
							}
						)}
					</Carousel>
				</div>
			}
		</div>
	</div>
);

export default VHSProcess;

